export const PaginationStyles = () => ({
  pagination: {
    gridColumn: '1 / 2',
    gridRow: '1 / 2',
    border: '1px solid #e0e0e0',
    maxWidth: '240px',
    borderRadius: '100px',
    justifySelf: 'center',
    marginLeft: '215px',
    '& .MuiPagination-ul': {
      '& li': {
        borderLeft: '1px solid #e0e0e0',
        '& .MuiButtonBase-root': {
          color: 'rgba(120, 125, 134, 0.5)',
          borderRadius: '0',
          margin: 0,
          '.MuiTouchRipple-root': {
            display: 'none',
          },
        },
        '& .Mui-selected': {
          color: 'rgba(0, 0, 0, 1)',
          backgroundColor: '#fff',
        },
      },
      '& li:first-of-type, li:last-of-type': {
        borderLeft: 'none',
        '& .MuiButtonBase-root': {
          color: 'rgba(0, 0, 0, 1)',
          backgroundColor: 'transparent',
        },
      },
      '& li:last-of-type': {
        borderLeft: '1px solid #e0e0e0',
      },
    },
  },
  download: {
    gridColumn: '2 / 3',
    gridRow: '1 / 2',
  },
});
